export const OPEN_STATUSES = ["created", "sent", "delivered", "correct"];
export const isOpen = (env) => OPEN_STATUSES.includes(env.status);
export const isInFlight = (env) => ["sent", "delivered", "correct"].includes(env.status);

export const STATUS_TONE = {
  completed: "bg-emerald-600 text-white",
  delivered: "bg-sky-600 text-white",
  sent: "bg-amber-500 text-white",
  created: "bg-slate-500 text-white",
  correct: "bg-violet-600 text-white",
  declined: "bg-rose-600 text-white",
  voided: "bg-rose-600 text-white",
  timedout: "bg-rose-600 text-white",
};

export const fmtDate = (d, locale = "en-GB", withTime = false) =>
  d ? new Date(d).toLocaleString(locale, { day: "numeric", month: "short", year: "numeric", ...(withTime ? { hour: "2-digit", minute: "2-digit" } : {}) }) : "—";

export const daysAgo = (d) => (d ? Math.floor((Date.now() - new Date(d).getTime()) / 86400000) : null);

export const signerSummary = (env) => {
  const signers = env.signers || [];
  const signed = signers.filter((s) => s.signed_at).length;
  const viewed = signers.filter((s) => s.delivered_at && !s.signed_at).length;
  const declined = signers.filter((s) => s.status === "declined").length;
  return { total: signers.length, signed, viewed, declined, pending: Math.max(0, signers.length - signed - viewed - declined) };
};

export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
};
